module.exports = __webpack_public_path__ + "static/media/hrm.5e8babc1.png";